/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_Merge_InvalidInputs */

const en_error_organization_merge_invalid = /** @type {(inputs: Error_Organization_Merge_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These organizations cannot be merged:`)
};

/**
* | output |
* | --- |
* | "These organizations cannot be merged:" |
*
* @param {Error_Organization_Merge_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_merge_invalid = /** @type {((inputs?: Error_Organization_Merge_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_Merge_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_merge_invalid(inputs)
});